module.exports = __webpack_public_path__ + "img/ic_暂无数据.d9d62506.svg";